var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 25,
    viewBox: "0 0 37 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8333 21.875C32.5292 21.875 33.9012 20.4688 33.9012 18.75L33.9167 3.125C33.9167 2.2962 33.5918 1.50134 33.0136 0.915291C32.4353 0.32924 31.6511 0 30.8333 0H6.16667C4.45542 0 3.08333 1.39062 3.08333 3.125V18.75C3.08333 19.5788 3.40818 20.3737 3.98642 20.9597C4.56466 21.5458 5.34892 21.875 6.16667 21.875H0V25H37V21.875H30.8333ZM6.16667 18.75V3.125H30.8333V18.7656L6.16667 18.75ZM20.0417 8.01562C14.0446 8.85938 11.655 13.0156 10.7917 17.1875C12.9346 14.2656 15.7558 12.9375 20.0417 12.9375V16.3594L26.2083 10.5156L20.0417 4.6875V8.01562Z",
    fill: "#134F98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenShare);
export default __webpack_public_path__ + "static/media/ScreenShare.f21c6de44ab9e3c49930558665471b70.svg";
export { ForwardRef as ReactComponent };